import { type FC } from 'react';
import cn from 'classnames';

import { useAppSelector } from '@/redux/store';

import { animateDuration } from '../../config';
import { useWinnerTicketSteps } from '../../hooks';

import { TicketChar } from './TicketChar/TicketChar';

import css from './styles.module.scss';

interface WinnerTicketProps {
  className?: string;
  place: number;
}

const WinnerTicket: FC<WinnerTicketProps> = ({ className, place }) => {
  const { filteredValue, ticket } = useWinnerTicketSteps();
  const isAnimationActive = useAppSelector(
    (state) => state.lottery.isLotteryHappeningNow,
  );
  const ticketLength = ticket?.length;
  const delayStep = ticketLength ? animateDuration / ticketLength : 0;

  return (
    ticket && (
      <div className={cn('flex gap-1 items-center justify-center', className)}>
        {Array.from({ length: ticket.length }).map((_, index) => {
          let sign: undefined | string;

          if (isAnimationActive) {
            sign =
              filteredValue && filteredValue[index]
                ? filteredValue[index]
                : undefined;
          } else {
            sign = ticket ? ticket[index] : undefined;
          }

          return (
            <div key={index} className={css.numberWrapper}>
              {sign && (
                <TicketChar
                  value={!isNaN(+sign) ? Number(sign) : sign}
                  duration={delayStep}
                  place={place}
                />
              )}
            </div>
          );
        })}
      </div>
    )
  );
};

export { WinnerTicket };
